import { VFlow } from 'bold-ui'
import { useAcessoLotacaoOrEstagio } from 'components/auth/useAcessoLotacao'
import { PageContainer } from 'components/layout/PageContainer'
import { PageContent } from 'components/layout/PageContent'
import theme from 'config/theme'
import { useFlags } from 'config/useFlagsContext'
import { GarantiaAcessoSortEnum, TipoEstabelecimentoEnum } from 'graphql/types.generated'
import qs from 'qs'
import React, { useState } from 'react'
import { useLocation } from 'react-router'
import AtendimentoListing from 'view/atendimentos/components/AtendimentoListing'
import { AdicionarCidadaoButton } from 'view/atendimentos/list/AdicionarCidadaoButton'

import GarantiaAcessoForm from './cadastro/GarantiaAcessoForm'
import GarantiaAcessoTableFilter from './filtros/GarantiaAcessoTableFilter'
import GarantiaAcessoTable from './GarantiaAcessoTable'
import { GarantiaAcessoFilterModel, GarantiaAcessoOrigemRegistroEnum } from './model-garantiaAcesso'

interface UrlParams {
  cidadaoId: string
}

export default function GarantiaAcessoView() {
  const location = useLocation()

  const { PILOTO_INTEGRACAO_REGULACAO_ENABLED } = useFlags()

  const {
    acesso: {
      unidadeSaude: { tipoEstabelecimento },
    },
  } = useAcessoLotacaoOrEstagio()
  const isCEO = tipoEstabelecimento === TipoEstabelecimentoEnum.CEO

  const urlParams: UrlParams = qs.parse(location.search, {
    ignoreQueryPrefix: true,
    parameterLimit: 5,
  })

  const [filter, setFilter] = useState<GarantiaAcessoFilterModel>({
    nomeCpfCns: '',
    lotacoes: [],
    equipes: [],
    tiposAtendimento: [],
    tiposServico: [],
    origem: isCEO
      ? [GarantiaAcessoOrigemRegistroEnum.GARANTIA_ACESSO]
      : [GarantiaAcessoOrigemRegistroEnum.CUIDADO_COMPARTILHADO, GarantiaAcessoOrigemRegistroEnum.GARANTIA_ACESSO],
    ordenacao: GarantiaAcessoSortEnum.CLASSIFICACAO_DE_PRIORIDADE,
    periodo: null,
    pageParams: {
      size: 15,
    },
  })

  return PILOTO_INTEGRACAO_REGULACAO_ENABLED ? (
    <PageContent fluid type='transparent' style={{ paddingTop: '1rem' }}>
      <PageContainer fluid style={{ backgroundColor: theme.pallete.surface.main, padding: '1rem 1rem 1rem 1rem' }}>
        <VFlow>
          <AdicionarCidadaoButton
            cidadaoId={urlParams.cidadaoId}
            dataTestId='adicionarCidadaoGarantiaAcesso'
            formComponent={<GarantiaAcessoForm cidadaoId={urlParams.cidadaoId} />}
          />

          <GarantiaAcessoTableFilter filter={filter} setFilter={setFilter} />
          <GarantiaAcessoTable filter={filter} onChangeFilter={setFilter} />
        </VFlow>
      </PageContainer>
    </PageContent>
  ) : (
    <AtendimentoListing
      heading={
        <AdicionarCidadaoButton
          cidadaoId={urlParams.cidadaoId}
          dataTestId='adicionarCidadaoGarantiaAcesso'
          formComponent={<GarantiaAcessoForm cidadaoId={urlParams.cidadaoId} />}
        />
      }
      filter={<GarantiaAcessoTableFilter filter={filter} setFilter={setFilter} />}
      children={<GarantiaAcessoTable filter={filter} onChangeFilter={setFilter} />}
      footer={undefined}
    />
  )
}
